import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from '../../redux/reducer/user';
import { updatePassword } from '../../api';
import { b64EncodeUnicode } from '../../utils/utils';

@connect(
  null,
  {logout}
)
export default class MainPanel extends Component{
  componentDidMount() {
    let {logout} = this.props;
    this.psValidate =  $("#changePasswordForm").validate({
      rules: {
        oldPassword: {
          required: true,
          minlength: 6,
          maxlength: 20
        },
        newPassword: {
          required: true,
          minlength: 6,
          maxlength: 20
        },
        confirmPassword: {
          required: true,
          minlength: 6,
          maxlength: 20,
          equalTo: "#newPassword"
        }
      },
      messages: {
        oldPassword: {
          required: 'Please enter your old password'
        },
        newPassword: {
          required: 'Please enter your new password'
        },
        confirmPassword: {
          required: 'Please enter your confirm password',
          equalTo: 'Please enter the same password'
        }
      },
      submitHandler:function(){
        $("#submit").button("loading");
        let body = {
          email: b64EncodeUnicode(sessionStorage.getItem("adminName")),
          oldPassword: $('#oldPassword').val(),
          newPassword: $('#newPassword').val(),
          confirmPassword: $('#confirmPassword').val()
        };
        updatePassword(body)
          .then(res=>{
            $("#submit").button("reset");
            window.onresize();
            $.sound_on = false;
            $.SmartMessageBox({
              title : "Success",
              content : res.message,
              buttons : '[Confirm]'
            }, function(ButtonInfo){
              if(ButtonInfo === "Confirm"){
                $(".modal-backdrop").remove();
                logout();
              }
            });
          })
          .catch(err=>{
            console.log(err);
            $("#submit").button("reset");
          });
      },
      errorPlacement: function (error, element) {
        error.insertAfter(element.parent());
      }
    });
  }
  _resetForm = () => {
    this.psValidate.resetForm();
    $("#oldPassword").val("");
    $("#newPassword").val("");
    $("#confirmPassword").val("");
    $(".state-success").removeClass("state-success");
    $(".state-error").removeClass("state-error");
    $("em.invalid").remove();
  };
  render() {
    return (
      <div className="modal fade in"
           id="psModal"
           tabIndex="-1"
           role="dialog"
           aria-labelledby="myModalLabel"
           aria-hidden="false"
           style={{display: 'none', paddingRight: 17}}>
        <div className="modal-backdrop fade in"
             style={{height: 978, opacity: 0.2}} />
        <div className="modal-dialog"
             style={{
               zIndex: 1041,
               width: 305,
               marginTop: -150,
               marginLeft: -152,
               position: 'absolute',
               top: '50%',
               left: '50%'
             }} >
          <div className="modal-content jarviswidget-color-blueDark"
               style={{
                 backgroundColor: 'rgba(6, 6, 6, .4)',
                 boxShadow: '0 0 20px black',
                 border: 0,
                 borderRadius: 5
               }} >
            <form id="changePasswordForm" >
              <div className="modal-header"
                   style={{
                     borderBottom: '1px solid #777',
                     borderTopLeftRadius: 5,
                     borderTopRightRadius: 5
                   }} >
                <button type="button"
                        onClick={this._resetForm}
                        className="close psClose"
                        data-dismiss="modal"
                        aria-hidden="true">
                  ×
                </button>
                <h4 className="modal-title">Change Password</h4>
              </div>
              <div className="modal-body"
                   style={{
                     padding: '30px 20px 0'
                   }} >
                <div className="smart-form client-form">
                  <section className="form-group">
                    <label className="input">
                      <input type="password"
                             id="oldPassword"
                             name="oldPassword"
                             className="form-control"
                             placeholder="Old Password"
                             required="" />
                      <b className="tooltip tooltip-top-right">
                        <i className="fa fa-lock txt-color-teal" /> Please enter the old password
                      </b>
                    </label>
                  </section>
                  <br/>
                  <section className="form-group">
                    <label className="input">
                      <input type="password"
                             id="newPassword"
                             name="newPassword"
                             className="form-control"
                             placeholder="New Password"
                             required="" />
                      <b className="tooltip tooltip-top-right">
                        <i className="fa fa-lock txt-color-teal" /> Please enter the new password
                      </b>
                    </label>
                  </section>
                  <br/>
                  <section className="form-group">
                    <label className="input">
                      <input type="password"
                             id="confirmPassword"
                             name="confirmPassword"
                             className="form-control"
                             placeholder="Confirm Password"
                             required="" />
                      <b className="tooltip tooltip-top-right">
                        <i className="fa fa-lock txt-color-teal" /> Please confirm the new password
                      </b>
                    </label>
                  </section>
                </div>
              </div>
              <div className="modal-footer"
                   style={{borderTop: '1px solid #757575'}} >
                <button type="submit" id="submit" className="btn btn-primary">
                  Confirm
                </button>
                <button type="reset"
                        onClick={this._resetForm}
                        className="btn btn-success">
                  Reset
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/dashboard/mainPanel.js